function getFileExtensionFromUrl(url) {
    try {
        if (!url || typeof url !== 'string') {
            throw new Error('Invalid URL provided');
        }
        
        // Remove query parameters (everything after ?)
        const urlWithoutQuery = url.split('?')[0];
        
        // Extract filename from URL
        let filename = urlWithoutQuery.substring(urlWithoutQuery.lastIndexOf('/') + 1);

        // Check if filename contains a dot
        if (filename.indexOf('.') !== -1) {
            // Extract extension from filename (split by dot and get last part)
            let extension = filename.split('.').pop();
            // Remove any additional query parameters that might be in the extension
            extension = extension.split('?')[0].split('&')[0];
            return extension.toLowerCase();
        } else {
            throw new Error('No file extension found in the URL');
        }
    } catch (error) {
        console.error('Error extracting file extension:', error.message);
        return null;
    }
}
export {
    getFileExtensionFromUrl
}